import parseErrorMessage from 'helpers/parseErrorMessage'
import produce from 'immer'
import { cloneDeep } from 'lodash'
import { getType } from 'typesafe-actions'
import * as actions from './common.actions'
import { CommonAction, CommonState, Event, Meta } from './common.types'

export const initEvent = {
  IsLoading: false,
  SubmitError: '',
  SubmitSuccess: false,
  SubmitType: '',
  MessageSuccess: '',
} as Event

export const initMeta = {
  page: 0,
  pageCount: 0,
  perPage: 0,
  totalCount: 0,
} as Meta

const initialState: CommonState = {
  token: undefined,
  addressList: {
    event: cloneDeep(initEvent),
    data: [],
  },
}

export default function(state: CommonState = initialState, action: CommonAction) {
  return produce(state, draft => {
    let response
    switch (action.type) {
      case getType(actions.changeToken):
        return {
          ...state,
          token: action.payload,
        }
      case getType(actions.getAddressAction.request):
        draft.addressList.event = cloneDeep(initEvent)
        draft.addressList.event.IsLoading = true
        return draft
      case getType(actions.getAddressAction.success):
        response = action.payload
        draft.addressList.event.IsLoading = false
        draft.addressList.event.SubmitSuccess = true
        draft.addressList.data = response.data
        return draft
      case getType(actions.getAddressAction.failure):
        draft.addressList.event.IsLoading = false
        draft.addressList.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      default:
        return state
    }
  })
}
